document.addEventListener('algolia.hooks.initialize', function() {

	// Filter search bar for allowed collections
	algoliaShopify.hooks.registerHook('beforeAutocompleteFiltersString', function(_defaultFilter) {
		// Filters for stock policy
		let stockPolicyFilter = '';

		if (algoliaShopify.config.stock_policy === 'deny') {
			// For 'deny' we will filter out all items based on inventory quantity
			stockPolicyFilter = 'inventory_quantity > 0';
		} else if (algoliaShopify.config.stock_policy === 'continue') {
			/**
			 * For 'continue' we will filter on `inventory_available` attribute whose
			 * value is dependent on:
			 * `inventory_quantity > 0 OR inventory_policy == 'continue'`
			 */
			stockPolicyFilter = 'inventory_available:true';
		}

		let filters = '';
		if(window.allowed_collections && window.allowed_collections.length > 0) {
			filters = (stockPolicyFilter != '' ? `${stockPolicyFilter}  AND ` : '')
				+ '(' + window.allowed_collections.map(c => 'collection_ids:' + c).join(' OR ') + ')' ;
		}
		else filters = _defaultFilter;

		return filters;
	});

	// Filter PLPs and search page for allowed collections
	algoliaShopify.hooks.registerHook('beforeInstantSearchFiltersString', function(_defaultFilter) {
		// Filters for stock policy
		let stockPolicyFilter = '';

		if (algoliaShopify.config.stock_policy === 'deny') {
			// For 'deny' we will filter out all items based on inventory quantity
			stockPolicyFilter = 'inventory_quantity > 0';
		} else if (algoliaShopify.config.stock_policy === 'continue') {
			/**
			 * For 'continue' we will filter on `inventory_available` attribute whose
			 * value is dependent on:
			 * `inventory_quantity > 0 OR inventory_policy == 'continue'`
			 */
			stockPolicyFilter = 'inventory_available:true';
		}

		let filters = '';
		if(window.allowed_collections && window.allowed_collections.length > 0) {
			filters = (stockPolicyFilter != '' ? `${stockPolicyFilter}  AND ` : '')
				+ '(' + window.allowed_collections.map(c => 'collection_ids:' + c).join(' OR ') + ')' ;
		}
		else filters = _defaultFilter;

		return filters;
	});

	// Main template
	algoliaShopify.hooks.registerHook('beforeInstantSearchMainTemplate', function(_defaultTemplate, data, html) {
		return html`
      <div class="ais-page">
        <h1 class="ais-h2">${algoliaShopify.translations.searchTitle}</h1>
        <div class="ais-input">
          <div class="ais-search-box-container"></div>
          <div class="ais-input-button">
            <div class="ais-clear-input-icon"></div>
          </div>
        </div>
        <div class="ais-facets-button">
          ${algoliaShopify.translations.showFilters}
        </div>
        <div class="ais-facets">
          <div class="ais-clear-refinements-container"></div>
          <div class="ais-current-refined-values-container"></div>
          ${data.facets.map(
			facet =>
				html`
                <div
                  class="ais-facet-dropdown-wrapper ais-facet-${facet.type} ais-facet-${facet.escapedName}"
                >
                  <label
                    for="${facet.escapedName}"
                    class="ais-range-slider--header ais-facet--header ais-header facet-toggle"
                    ><span>${facet.title}</span>
											<span class="angle angle-down">
											\t<span class="angle-icon"></span>
											</span>
									</label>
                  <input
                    class="ais-dropdown-checkbox"
                    type="checkbox"
                    id="${facet.escapedName}"
                    name="dropdown"
                  />
                  <div
                    class="ais-facet-${facet.escapedName}-container ais-facet-dropdown-container"
                  ></div>
                </div>
              `
		)}
					<div class="range-input"></div>
        </div>
        <div class="ais-block">
          <div class="ais-search-header">
            <div class="ais-stats-container"></div>
            <div class="ais-change-display">
              <span class="ais-change-display-block ais-change-display-selected"
                ><i class="fa fa-th-large"></i
              ></span>
              <span class="ais-change-display-list"
                ><i class="fa fa-th-list"></i
              ></span>
            </div>
            <div class="ais-sort">
              ${data.multipleSortOrders
			? html`
                    ${algoliaShopify.translations.sortBy}
                    <span class="ais-sort-orders-container"></span>
                  `
			: html`
                    ${algoliaShopify.translations.sortBy}
                    ${algoliaShopify.translations.relevance}
                  `}
            </div>
          </div>
          <div class="ais-hits-container ais-results-as-block"></div>
        </div>
        <div class="ais-pagination-container"></div>
      </div>
    `;
	});

	algoliaShopify.hooks.registerHook('beforeInstantSearchStatsTemplate', function(_defaultTemplate, data, html) {
		return html`
          <span class="ais-stats--nb-results">
            ${algoliaShopify.helpers.formatNumber(data.nbHits)} ${' '}
            Products
          </span>
    `;
	});

	// Collections filter
	algoliaShopify.hooks.registerHook('beforeInstantSearchFacetParamsOptions', function(params, facet) {
		//console.log('params',params)
		//console.log('facet',facet)
		if (facet.name == "collections") {
			return {
				...params,
				transformItems(items) {
					return items.map(item => {
						if(window.all_collections.hasOwnProperty(item.value)) {
							item.title = window.all_collections[item.value];
						}
						return item;
					});
				},
				templates: {
					item(item, { html }) {
						return html`<li class="ais-RefinementList-item ais-facet--item"><div><label class="ais-RefinementList-label ais-facet--label">${item.title}<span class="ais-RefinementList-count ais-facet--count-distinct">${item.count}</span></label></div></li>`;
					},
				},
			}
		}

		return {
			...params
		}
	});



	// Style facets header
	algoliaShopify.hooks.registerHook('beforeInstantSearchFacetPanelOptions', function(params, facet) {
		/*if (facet.name == "collections" || facet.title == "Collections") {
			return {
				...params,
				templates: {
					// To avoid duplicate headers use the `beforeInstantSearchMainTemplate` hook and remove the  'ais-facet-dropdown-wrapper' container
					header(options, { html }) {
						if (options.results) {
							return html`<label
								for="${facet.escapedName}"
								class="ais-range-slider--header ais-facet--header ais-header facet-toggle"
							><span>All Departments</span>
								<span class="angle angle-down">
											\t<span class="angle-icon"></span>
											</span>
							</label>`;
							//return html`<label for="collections" class="ais-range-slider--header ais-facet--header ais-header">All Departments<span class="expand"></span></label>`;
							//return html`<span class="ais-facet--header">Tags Header (${options.results.nbHits} results)</span>`;
						}
					},
				}
			}
		}*/

		/*if (facet.type == "disjunctive") {
			return {
				...params,
				templates: {
					footer(options, { html }) {
						if (options.results) {
							return html`<span class="ais-facet--footer">Disjunctive footer (${options.results.nbHits} results)</span>`;
						}
					},
					searchableNoResults(data, { html }) {
						return html`<span>No results</span>`;
					},
				}
			}
		}*/

		return {
			...params
		}
	});


});

/*
var instantsearch = window.instantsearch;
const { rangeInput } = instantsearch.widgets;
rangeInput({
	container: '.range-input',
	attribute: 'price',
	min: 10,
	max: 100,
});*/